var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close-button",attrs:{"aria-label":"Schließen"},on:{"click":function($event){$event.preventDefault();return _vm.close($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }